import React from 'react';
import 'react-datetime/css/react-datetime.css';
import './assets/tailwind-compiled.css';
import 'toastify-js/src/toastify.css';
import {App} from './App';
import {DATE_TIME_FORMAT_COOKIE, isTestEnv} from './helpers/helpers';
import {initializeYBug} from './helpers/ybug';
import MusculaLog from '@muscula.com/muscula-webapp-js-logger';
import Cookies from 'js-cookie';
import {createRoot} from 'react-dom/client';

if (Cookies.get(DATE_TIME_FORMAT_COOKIE)) {
    Cookies.set(DATE_TIME_FORMAT_COOKIE, 'YYYY-MM-DD HH:mm:ss');//TODO: usunąć kiedyś, poprawka formatu
}

if (document.location.hostname === 'localhost') {
    MusculaLog.Init('8PjeSqgW7L8', 'https://localhost:6001');
} else {
    MusculaLog.Init(isTestEnv() ? 'd6GY3T0CE' : 'eT1ofd4pRY3s5m', isTestEnv() ? 'https://harvester.test.muscula.com' : undefined);
}

if (!isTestEnv()) {
    setTimeout(initializeYBug, 2000);
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);


